import {
  WebSocketChannel,
  type WebSocketVoiceFullTranscriptMessage,
  useWebSocketListener,
} from "@huub-web/backend";
import { usePubSub, useDebug } from "@huub-web/ui";
import { useNavigationState } from "../../providers";

/**
 * Listens to the WebSocketVoiceFullTranscriptMessage and publishes it to the pubSub.
 * Which is picked up by the useChatMessages hook and added to the conversation.
 * Bit of a workaround to add the lower level navigation context into the transcript.
 */
export const TranscriptListener = () => {
  const pubSub = usePubSub();
  const { navigationContext } = useNavigationState();
  const { log } = useDebug();

  // User transcripts
  // ------------

  useWebSocketListener<WebSocketVoiceFullTranscriptMessage>(
    WebSocketChannel.VOICE_FULL_TRANSCRIPT,
    (received) => {
      log(
        "cyan",
        "useChatMessages",
        "WebSocketVoiceFullTranscriptMessage",
        received.data,
      );

      if (received.data.message) {
        pubSub.publish("onFullTranscript", {
          value: received.data.message,
          context: navigationContext ?? [],
        });
      }
    },
  );

  return null;
};
